var stjude = {
  $ready: [],
  digitalData: {
    sysEnv: {
      siteCode: "bac",
      environment: process.env.REACT_APP_ENV,
    },
    page: {
      path: "",
      pageName: "", //please pass unique page name for each page
      language: "english",
      eventCode: "",
    },
    user: {
      userid: "anonymous",
      authState: "logged out",
    },
    event: [],
  },
};

window.stjude = stjude;

//While unlikely, it's possible that pushEvents start rolling in before adobe analytics has loaded.
//If that happens, we'll cache them here, and just push them all when it finishes
let isAdobeLoaded = true;
const earlyBirdEvents = [];

function flushEvents() {
  isAdobeLoaded = true;
  while (earlyBirdEvents.length > 0) {
    PushEvent(earlyBirdEvents.shift());
  }
}

/**
 * Adds the adobe analytics script tag to the page, and since the page name in the analytics object. Sets an onload event to flush events that have been queued up if necessary
 * @param {*} name
 * @param {*} eventCode
 */
export function SetPage(name, eventCode = "") {
  stjude.digitalData.page.pageName = name;
  if (eventCode != null) stjude.digitalData.page.eventCode = eventCode;
  const adobeScript = document.createElement("script");
  adobeScript.src = `https://assets.adobedtm.com/f904784c6d75/95cb7a9eb90b/${process.env.REACT_APP_ENV_SCRIPT}`;
  adobeScript.async = true;
  adobeScript.onload = () => {
    flushEvents();
  };
  document.head.appendChild(adobeScript);
}

/**
 * Pre-makes an eventInfo for a scan event, and then passes it to PushEvent
 * @param {*} name
 * @param {*} isSuccess
 */
export function pushScanEvent(name, isSuccess) {
  PushEvent({
    eventInfo: {
      eventName: name, //pass name of the respective art work for each scan
      eventType: "", //pass this whenever a scan occurs
      eventAction: isSuccess ? "success" : "failure", // If for some reason the scan is unsuccessful pass “failure”
      timeStamp: new Date(),
    },
  });
}
/**
 * Puts events (or queues them for later) on the analytics object
 * @param {{eventInfo:{eventName:string,eventType:string,eventAction:string,timeStampe:Date}}} event
 */
export function PushEvent(event) {
  if (isAdobeLoaded) {
    // console.log("Pushing event");
    window.stjude.digitalData.event.push(event);
  } else earlyBirdEvents.push(event);
}
